// license slider
const swiperlicense = new Swiper(".license__slider", {
  loop: true,
  spaceBetween: 1,
  slidesPerView: "auto",
  speed: 800,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".license__slider-next",
    prevEl: ".license__slider-prev",
  },
  breakpoints: {
    768: {
      spaceBetween: 32,
    },
    992: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
  },
});

// license popup slider
const swiperlicensePopup = new Swiper(".license__popup__slider", {
  loop: true,
  spaceBetween: 0,
  speed: 400,
  slidesPerView: 1,
  effect: "fade",
  navigation: {
    nextEl: ".license__popup__slider-next",
    prevEl: ".license__popup__slider-prev",
  },
  pagination: {
    el: ".license__popup__slider-pagination",
    clickable: true,
  },
  thumbs: {
    swiper: swiperlicense,
  },
});

// open popup on click
document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector(".license__popup");
  const body = document.body;

  document.body.addEventListener("click", (e) => {
    const clickedSlide = e.target.closest(".license__slider .swiper-slide");

    if (clickedSlide && swiperlicense && swiperlicense.slides) {
      const slideIndex = swiperlicense.slides.indexOf(clickedSlide);

      if (slideIndex !== -1) {
        const realIndex = swiperlicense.slides[slideIndex].dataset
          .swiperSlideIndex
          ? parseInt(
              swiperlicense.slides[slideIndex].dataset.swiperSlideIndex,
              10
            )
          : swiperlicense.realIndex;

        if (!isNaN(realIndex)) {
          popup.classList.add("open");
          body.classList.add("body-license-open");
          swiperlicensePopup.slideToLoop(realIndex);
        }
      }
      return;
    }
    const closeBtn = e.target.closest(".license__popup__close");
    if (closeBtn) {
      popup.classList.remove("open");
      body.classList.remove("body-license-open");
    }
  });
});
